<div class="page">

  <div class="pagehead">
    <div>
      <h1>TDS certificate</h1>
      <p>Download your quarterly TDS certificate for filing</p>
    </div>
  </div>

  <div class="row-2-1">
    <div class="card form-card">
      <div class="clabel"><svg viewBox="0 0 24 24"><path d="M6 3h9l3 3v15H6z"/><path d="M9 12h6M9 16h6"/></svg>Certificate period</div>
      <div class="kit-form">
        <div class="er-field">
          <label class="er-field__label" for="tds-year">Assessment year</label>
          <select id="tds-year" class="er-select" (change)="selectYear({ value: $any($event.target).value })">
            <option *ngFor="let i of yearArray" [value]="i" [selected]="i === selectedYear">{{ i }}</option>
          </select>
        </div>

        <div class="er-field">
          <label class="er-field__label">Quarter</label>
          <div class="seg seg--sub quarters">
            <button type="button" [class.on]="selectedQuarter == 'Q1'" (click)="selectQuarter('Q1')">Q1</button>
            <button type="button" [class.on]="selectedQuarter == 'Q2'" (click)="selectQuarter('Q2')">Q2</button>
            <button type="button" [class.on]="selectedQuarter == 'Q3'" (click)="selectQuarter('Q3')">Q3</button>
            <button type="button" [class.on]="selectedQuarter == 'Q4'" (click)="selectQuarter('Q4')">Q4</button>
          </div>
        </div>

        <div class="er-field__error cert-error" *ngIf="pdfurl == 'false'">
          <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>
          No certificate found for the selected year and quarter
        </div>

        <div class="form-actions">
          <button type="button" class="er-btn er-btn--primary" (click)="callAPITdsCertificate()">
            <i class="fa fa-download" aria-hidden="true"></i>&nbsp;Download TDS certificate
          </button>
        </div>
      </div>
    </div>

    <div class="card art-card">
      <img src="../../assets/images/undraw_certificate_re_yadi.svg" alt="" class="art">
      <p class="art-hint">Certificates are issued per quarter against your PAN. If a quarter isn't available yet, check back after the filing cycle.</p>
    </div>
  </div>

</div>
